// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Inter/static/Inter_18pt-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Inter/static/Inter_18pt-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Inter/static/Inter_18pt-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Inter/static/Inter_24pt-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/Inter/static/Inter_24pt-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/Roboto/static/Roboto_Condensed-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/fonts/Montserrat/static/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Inter Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'Inter Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Inter SemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'Inter Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'Inter ExtraBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
    font-family: 'Roboto Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
    font-family: 'Montserrat SemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

:root {
    --color-bg: #F6F7F8;
    --color-primary: #2563eb;
    --color-secondary: #E49820;
    --text-primary: #2B6CB0;

    --font-small: 8px;
    --font-regular: 8.47px;
    --font-rm: 9px;
    --font-rm-2: 10px;
    --font-medium: 12px;
    --font-large: 12.22px;
    --font-xlarge: 14px;
    --font-xxlarge: 15.06px;
    --font-xxxlarge: 18px;

    --font-22: 22px;
    --font-11: 11px;
    --font-16: 16.50px;
    --font-heading: 24px;
    --font-heading-2: 22.81px;
    --font-heading-3: 21.81px;
    --font-heading-4: 16.95px;
    --font-heading-5: 16px;
    --text-large: 32px;
    --text-large-1: 36px;
    --text-large-2: 42px;

    --text-color-primary: #000000;
    --text-color-secondary: #FCB215;
    --text-color-white: #ffffff;
    --text-color-black: #000000;

    --color-white: #ffffff;
    --color-black: #000000;
    --color-title: #2F313A;
    --color-subtitle: #080808;

    --btn-color-primary: #0F84B0;
    --btn-color-secondary: #086396;

    --border-color-primary: #0F84B0;

    --text-color-gray: #6B7280;
    --color-grey: #AAAAAA;
    --color-grey-2: #A5A5A5;
    --color-grey-3: #7B8193;
    --color-grey-4: #3C3C3C;
    --color-grey-5: #4A4A4A;

    --badge-primary: #BBD7C1;
    --color-green: #318B41;

    --font-inter-regular: 'Inter Regular', sans-serif;
    --font-inter-medium: 'Inter Medium', sans-serif;
    --font-inter-semi-bold: 'Inter SemiBold', sans-serif;
    --font-inter-bold: 'Inter Bold', sans-serif;
    --font-inter-extra-bold: 'Inter ExtraBold', sans-serif;

    --font-roboto-bold: 'Roboto Bold', sans-serif;
    --font-monsterrat-semi-bold: 'Montserrat SemiBold', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/utils/variables.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,+DAAqF;AACzF;;AAEA;IACI,2BAA2B;IAC3B,+DAAoF;AACxF;;AAEA;IACI,6BAA6B;IAC7B,+DAAsF;AAC1F;;AAEA;IACI,yBAAyB;IACzB,+DAAkF;AACtF;;AAEA;IACI,8BAA8B;IAC9B,+DAAuF;AAC3F;;AAEA;IACI,0BAA0B;IAC1B,+DAAyF;AAC7F;;AAEA;IACI,kCAAkC;IAClC,+DAA2F;AAC/F;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;;IAEvB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;;IAErB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;;IAEpB,6BAA6B;IAC7B,+BAA+B;IAC/B,2BAA2B;IAC3B,2BAA2B;;IAE3B,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;;IAEzB,4BAA4B;IAC5B,8BAA8B;;IAE9B,+BAA+B;;IAE/B,0BAA0B;IAC1B,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;;IAEvB,wBAAwB;IACxB,sBAAsB;;IAEtB,iDAAiD;IACjD,+CAA+C;IAC/C,oDAAoD;IACpD,2CAA2C;IAC3C,sDAAsD;;IAEtD,6CAA6C;IAC7C,8DAA8D;AAClE","sourcesContent":["@font-face {\n    font-family: 'Inter Regular';\n    src: url('../../public/fonts/Inter/static/Inter_18pt-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter Medium';\n    src: url('../../public/fonts/Inter/static/Inter_18pt-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter SemiBold';\n    src: url('../../public/fonts/Inter/static/Inter_18pt-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter Bold';\n    src: url('../../public/fonts/Inter/static/Inter_24pt-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter ExtraBold';\n    src: url('../../public/fonts/Inter/static/Inter_24pt-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Roboto Bold';\n    src: url('../../public/fonts/Roboto/static/Roboto_Condensed-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Montserrat SemiBold';\n    src: url('../../public/fonts/Montserrat/static/Montserrat-SemiBold.ttf') format('truetype');\n}\n\n:root {\n    --color-bg: #F6F7F8;\n    --color-primary: #2563eb;\n    --color-secondary: #E49820;\n    --text-primary: #2B6CB0;\n\n    --font-small: 8px;\n    --font-regular: 8.47px;\n    --font-rm: 9px;\n    --font-rm-2: 10px;\n    --font-medium: 12px;\n    --font-large: 12.22px;\n    --font-xlarge: 14px;\n    --font-xxlarge: 15.06px;\n    --font-xxxlarge: 18px;\n\n    --font-22: 22px;\n    --font-11: 11px;\n    --font-16: 16.50px;\n    --font-heading: 24px;\n    --font-heading-2: 22.81px;\n    --font-heading-3: 21.81px;\n    --font-heading-4: 16.95px;\n    --font-heading-5: 16px;\n    --text-large: 32px;\n    --text-large-1: 36px;\n    --text-large-2: 42px;\n\n    --text-color-primary: #000000;\n    --text-color-secondary: #FCB215;\n    --text-color-white: #ffffff;\n    --text-color-black: #000000;\n\n    --color-white: #ffffff;\n    --color-black: #000000;\n    --color-title: #2F313A;\n    --color-subtitle: #080808;\n\n    --btn-color-primary: #0F84B0;\n    --btn-color-secondary: #086396;\n\n    --border-color-primary: #0F84B0;\n\n    --text-color-gray: #6B7280;\n    --color-grey: #AAAAAA;\n    --color-grey-2: #A5A5A5;\n    --color-grey-3: #7B8193;\n    --color-grey-4: #3C3C3C;\n    --color-grey-5: #4A4A4A;\n\n    --badge-primary: #BBD7C1;\n    --color-green: #318B41;\n\n    --font-inter-regular: 'Inter Regular', sans-serif;\n    --font-inter-medium: 'Inter Medium', sans-serif;\n    --font-inter-semi-bold: 'Inter SemiBold', sans-serif;\n    --font-inter-bold: 'Inter Bold', sans-serif;\n    --font-inter-extra-bold: 'Inter ExtraBold', sans-serif;\n\n    --font-roboto-bold: 'Roboto Bold', sans-serif;\n    --font-monsterrat-semi-bold: 'Montserrat SemiBold', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
